import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface BarChartProps {
  data: Array<{ dimension: string; value: number; percentage?: number }>;
  label?: string;
  color?: string;
  horizontal?: boolean;
}

export function BarChart({
  data,
  label = 'Value',
  color = '#667eea',
  horizontal = true,
}: BarChartProps) {
  const chartData = {
    labels: data.map((d) => truncateLabel(d.dimension, 25)),
    datasets: [
      {
        label,
        data: data.map((d) => d.value),
        backgroundColor: color,
        borderRadius: 4,
        maxBarThickness: 30,
      },
    ],
  };

  const options = {
    indexAxis: horizontal ? ('y' as const) : ('x' as const),
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#1a1a2e',
        titleColor: '#fff',
        bodyColor: '#fff',
        padding: 12,
        callbacks: {
          label: (context: { dataIndex: number; formattedValue: string }) => {
            const item = data[context.dataIndex];
            if (item.percentage !== undefined) {
              return `${context.formattedValue} (${item.percentage.toFixed(1)}%)`;
            }
            return context.formattedValue;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: !horizontal,
          color: '#e5e7eb',
        },
        ticks: {
          color: '#6b7280',
        },
      },
      y: {
        grid: {
          display: horizontal,
          color: '#e5e7eb',
        },
        ticks: {
          color: '#6b7280',
        },
      },
    },
  };

  return (
    <div style={{ height: `${Math.max(200, data.length * 35)}px` }}>
      <Bar data={chartData} options={options} />
    </div>
  );
}

function truncateLabel(label: string, maxLength: number): string {
  if (label.length <= maxLength) return label;
  return label.substring(0, maxLength - 3) + '...';
}
